import React from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { Option } from './newInvoice.types';

export interface PatientSourceSelectProps {
  options: Option[];
  value: string;
  onChange: (value: string) => void;
  error?: string;
  showErrors?: boolean;
  disabled?: boolean;
}

const PatientSourceSelect: React.FC<PatientSourceSelectProps> = ({
  options,
  value,
  onChange,
  error,
  showErrors,
  disabled = true,
}) => {
  return (
    <FormControl fullWidth size="small" error={!!(showErrors && error)} disabled={disabled}>
      <InputLabel>Select Patient Source</InputLabel>
      <Select
        label="Select Patient Source"
        value={value}
        onChange={(e) => onChange(e.target.value as string)}
        disabled={disabled}
      >
        {options.length === 0 ? (
          <MenuItem disabled value="">
            Please assign source from registration list
          </MenuItem>
        ) : (
          options.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>
              {opt.label}
            </MenuItem>
          ))
        )}
      </Select>
    </FormControl>
  );
};

export default PatientSourceSelect;
